import { useCallback } from "react";
import {
  getCCAFieldDefinitions,
  getCCARequiredFlags,
  getExistingCodes,
} from "../../api/AnalysisCodes";
import { useWorkOrderStore } from "../../store/wo-order";
import { completeWO } from "../../api/CompletionData";
import { logCustomMessage } from "../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useIonAlert } from "@ionic/react";

export default function useCompleteWo() {
  const [presentAlert] = useIonAlert();

  const completeWo = useCallback(async (body: any) => {
    const response = await completeWO(body);
    logCustomMessage(
      "Complete Work Order in Complete screen",
      SeverityLevel.Information,
      "WorkOrders/CompleteWorkOrder",
      body,
      response
    );
    return response;
  }, []);

  const completeWorkOrder = useCallback(
    async (payload: any, woNumber: string) => {
      const workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      const fields = await getCCAFieldDefinitions(workOrder?.Equipment);
      /* US 906024 - same union as useGetIsCAARequiredForCompletion: a Required flag on the
         EquipmentClass -> Component field mapping makes analysis codes mandatory for this
         equipment class, and this gate used to see only the element settings. Kept in step with
         that hook so the action bar and the actual completion never disagree. */
      const { componentRequired } = await getCCARequiredFlags({
        equipmentClass: workOrder?.EquipmentClass,
      });
      if (
        fields.componentField?.IsRequired ||
        fields.actionField?.IsRequired ||
        fields.conditionField?.IsRequired ||
        componentRequired
      ) {
        const dateCreated = workOrder?.Events?.DateCreated;
        const timeCreated = workOrder?.Events?.TimeCreated;
        if (dateCreated && timeCreated) {
          const existingCodes = await getExistingCodes(
            dateCreated,
            timeCreated
          );
          if (existingCodes && existingCodes.length > 0) {
            return await completeWo(payload);
          } else {
            presentAlert(`CCA is Required`);
            return;
          }
        }
      } else {
        return await completeWo(payload);
      }
    },
    [completeWo, presentAlert]
  );

  return { completeWorkOrder };
}
